import Typography from "@mui/material/Typography";
import {Button, Grid} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import DinoDialog from "../../../components/Dialog";
import useCallDataApi from "../../../hooks/data";
import Loading from "../../../components/Loading";
import Plan from "./Plan";
import {hasPermission} from "../../../utils/permissionUtils";
import {AuthContext} from "../../../context/AuthContext";
import DisabledWrapper from "../../../components/DisabledWrapper";
import ChangeCircleRoundedIcon from '@mui/icons-material/ChangeCircleRounded';
import useSubscriptionQueries from "../../../hooks/queries/useSubscriptionQueries";
import usePlanQueries from "../../../hooks/queries/usePlanQueries";

const Subscription = () => {
    const [current, setCurrent] = useState(null)

    const {subscriptionGetForBusinessQuery, useSubscriptionChangePlan, useSubscriptionCancelSubscription} = useSubscriptionQueries()
    const {planListQuery} = usePlanQueries()
    const {data: subscription, isPending: subscriptionLoading} = subscriptionGetForBusinessQuery
    const {data: plans, isPending: plansLoading} = planListQuery

    const change = useSubscriptionChangePlan({})
    const cancel = useSubscriptionCancelSubscription({})

    const {getUser} = useContext(AuthContext)
    const user = getUser()


    const changePlan = planId => change.mutate({new_plan: planId})

    const cancelSubscription = () => cancel.mutate()


    const [deleteSubscriptionDialogOpen, setDeleteSubscriptionDialogOpen] = useState(false)
    const [changePlanOpen, setChangePlanOpen] = useState(false)

    const subscriptionDeleteActions = <>
        <Button variant='outlined' style={{padding: 15}}
                onClick={() => setDeleteSubscriptionDialogOpen(false)}>Mégsem</Button>
        <Button variant='contained' style={{padding: 15}} onClick={() => {
            setDeleteSubscriptionDialogOpen(false)
            cancelSubscription()
        }} endIcon={<DeleteForeverRoundedIcon/>}>Előfizetés lemondása</Button>
    </>
    const changePlanActions = <>
        <Button variant='outlined' style={{padding: 15}}
                onClick={() => setChangePlanOpen(false)}>Mégsem</Button>
        <Button variant='contained' style={{padding: 15}} onClick={() => {
            setChangePlanOpen(false)
            changePlan(current)
        }} endIcon={<ChangeCircleRoundedIcon/>}>Előfizetés megváltoztatása</Button>
    </>

    const disabledCause = [{
        disabled: !hasPermission(user, 'subscription', 'update'),
        message: 'Nincs jogosultságod a művelet végrehajtásához!'
    }]

    if (subscriptionLoading || plansLoading || change.isPending || cancel.isPending) return <Loading isLoading />

    return <div className="white-card">
        <Typography variant='subtitle2'>Előfizetési csomagok</Typography>
        <Typography variant='body2' color='#536B74' gutterBottom>
            Előfizetési csomag váltása esetén a kisebb csomag a következő fordulópontkor vált, tehát a kifizetett összeg
            elhasználódik és a következő fordulóponttól lesz kevesebb.
            A nagyobb csomagra váltás esetén pedig a különbözet kifizetése után lép életbe.
        </Typography>
        <Grid container spacing={1} marginBottom={2} marginTop={2}>
            {plans?.map(plan => <Grid item xs={12} key={`plan-${plan.id}`}>
                <Plan
                    isCurrent={plan.id === subscription?.plan}
                    isNext={plan.id === subscription?.next}
                    name={plan.name}
                    icon={plan.icon}
                    description={plan.description}
                    price={plan.price}
                    months={plan.months}
                    changePlane={() => {
                        setCurrent(plan.id)
                        setChangePlanOpen(true)
                    }}
                />
            </Grid>)}
        </Grid>
        <DisabledWrapper disabledCause={disabledCause}>
            <Button onClick={() => setDeleteSubscriptionDialogOpen(true)}>Előfizetés lemondása</Button>
        </DisabledWrapper>

        <DinoDialog open={changePlanOpen}
                    handleClose={() => setChangePlanOpen(false)}
                    title='Előfizetés megváltoztatása'
                    subtitle='Ha módosítod az előfizetésedet, a változások az alábbi módon lépnek életbe:
                        Ha kisebb csomagra váltasz: egyes funkciók többé nem lesznek elérhetők — a meglévő adatok nem törlődnek, csak nem jelennek meg a foglaló oldalon. Ha az új csomag nem engedélyez több kollégát, azok a felhasználók nem fognak tudni belépni a rendszerbe. Az olcsóbb csomag ára a következő havi számlázástól lép érvénybe.
                        Ha nagyobb csomagra váltasz: a jelenlegi csomagod fel nem használt időarányos díja beszámításra kerül, és levonásra kerül az új csomag díjából. A nagyobb csomag a fizetés banki visszaigazolása után lép életbe.
                        Fizetés esetén a megadott kártyáról vonjuk le a pénzt.
                        Folytatod a módosítást?
                    '
                    actions={changePlanActions}>
        </DinoDialog>

        <DinoDialog open={deleteSubscriptionDialogOpen}
                    handleClose={() => setDeleteSubscriptionDialogOpen(false)}
                    title='Előfizetés lemondása'
                    subtitle='Biztosan lemondja az előfizetést? Az aktuális hónap végével nem fogja tudni használani a rendszert!'
                    actions={subscriptionDeleteActions}>
        </DinoDialog>

    </div>
}

export default Subscription